import { useQueryClient, useMutation, useQuery } from 'react-query'

import { ReportVoucherRedemptionCountCreateFormTypes } from 'schemas/reports-voucher-count-schemas';
import { postReportVoucherRedemptionCountService } from 'api/reports-voucher-redemption-count';

export const useReportVoucherRedemptionQuery = (payload: ReportVoucherRedemptionCountCreateFormTypes) => {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useReportVoucherRedemptionQuery', payload],
    queryFn: async () => {
      return await postReportVoucherRedemptionCountService(payload);
    },
  })
  
  return query;
}


export const useReportVoucherRedemptionMutation = () => {
  // const queryClient = useQueryClient();
  
  const mutationFn = async (payload: ReportVoucherRedemptionCountCreateFormTypes) => {
    return await postReportVoucherRedemptionCountService(payload);
  };

  const mutation = useMutation({
    mutationFn,
    // onError: (error: string) => {},
    // onSuccess: (data) => {},
  });

  return mutation;
};
